import { Entity, Key } from '@briebug/ngrx-auto-entity';
import { User } from '../user/user.model';

@Entity({ modelName: "Groupe", uriName: "groupes" })
export class Groupe {
    @Key id: number;
    name: string;
    rowVersion: number;
    users: User[];
    constructor() {
        this.users = [];
     
    }
}


